import script from "./MermaidDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./MermaidDialog.vue?vue&type=script&setup=true&lang=js"

import "./MermaidDialog.vue?vue&type=style&index=0&id=be483fb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be483fb2"]])

export default __exports__